import { useMemo } from 'react'
import { SurveyModel } from 'survey-core'

type SurveyJson = NonNullable<SurveyModel['json']>

export function useDynamicSurveyPrefill(
  originalSurveyJson: SurveyJson,
  placeholderValues: Record<string, string | number>,
): SurveyJson {
  return useMemo(() => {
    const clonedJson: SurveyJson = JSON.parse(JSON.stringify(originalSurveyJson))

    if (!clonedJson.elements || !Array.isArray(clonedJson.elements)) return clonedJson

    clonedJson.elements = Array.isArray(clonedJson.elements)
      ? clonedJson.elements.map((question: SurveyJson) => {
          if (typeof question.defaultValue === 'string') {
            const placeholder = Object.keys(placeholderValues).find((key) => question.defaultValue!.includes(key))

            if (placeholder) {
              const actualValue = placeholderValues[placeholder]
              if (actualValue !== undefined) {
                question.defaultValue = actualValue
                question.readOnly = true
              }
            }
          }

          return question
        })
      : []

    return clonedJson
  }, [originalSurveyJson, placeholderValues])
}
